import { gql } from '__generated__';

export default gql(`
  mutation EditMailPermission($input: EditMailPermissionInput!) {
    editMailPermission(input: $input) {
      id
      title
      label
    }
  }
`);
